export const getNotifications = (state) => {
	return state.notifications;
}
